'use client';

import { useSearchParams } from 'next/navigation';
import ResultsPanel from '@/components/ResultsPanel';
import Link from 'next/link';

export default function ResultsContent() {
  const searchParams = useSearchParams();
  const sessionId = searchParams.get('s') || 'demo-session';

  return (
    <main className="min-h-screen p-4">
      <div className="max-w-4xl mx-auto">
        <header className="mb-6">
          <Link
            href="/"
            className="text-blue-500 hover:underline text-sm mb-2 block"
          >
            ← Back to Home
          </Link>
          <h1 className="text-3xl font-bold">Session Results</h1>
          <p className="text-gray-500">Session: {sessionId}</p>
        </header>

        <ResultsPanel sessionId={sessionId} />
      </div>
    </main>
  );
}
